<footer id="sticky-footer" class="py-2 text-gray-50 appFooter container-fluid">
  <div class="footer-section row">
    <div
      class="col-md-1 logocontainer"
      [ngStyle]="{ 'text-align': currentLang == 'ar' ? 'left' : 'right' }"
    >
      <img class="logoScam" src="../../../assets/img/images/ShapeLogo.png" />
    </div>
    <br />
    <div class="col-md-3 foottext">
      <small class="footer-text"
        >{{ "copyrights" | translate }} &copy; {{ currentYear }} <br />
        <span class="tou">
          <a [routerLink]="['/pages/AboutTheProgram/UsePolicy']">{{
            "privacy" | translate
          }}</a>
          |
          <a [routerLink]="['/pages/AboutTheProgram/TermsOfUse']">{{
            "usage" | translate
          }}</a>
        </span>
      </small>
    </div>
    <div class="col-md-6 foottext">
      <div class="socialMediaIcons">
        <div>
          <a href="https://www.youtube.com/cpaksa1"
            ><i class="fab fa-youtube"></i
          ></a>
        </div>
        <div>
          <a href="https://twitter.com/cpaksa"
            ><i class="fab fa-twitter-square"></i
          ></a>
        </div>
        <div>
          <a href="https://www.facebook.com/cpaksa"
            ><i class="fab fa-facebook-square"></i
          ></a>
        </div>
        <div>
          <a href="http://instagram.com/cpaksa"
            ><i class="fab fa-instagram"></i
          ></a>
        </div>
        <div>
          <a href="https://telegram.me/cpaksa"
            ><i class="fab fa-telegram"></i
          ></a>
        </div>
        <div>
          <a href="https://www.snapchat.com/add/cpaksa"
            ><i class="fab fa-snapchat"></i
          ></a>
        </div>
      </div>
    </div>
    <br />
    <div class="col-md-2 logocpa">
      <a href="https://cpa.org.sa">
        <img class="footer-img" src="../../../assets/img/CPA logo.svg" />
      </a>
    </div>
  </div>
</footer>
